module.exports = __webpack_public_path__ + "img/reservation.b5a996c6.svg";